import React from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { fixFor, goToField } from "./readinessFixes";

const BTN = "border border-current px-2 py-1 text-[10px] uppercase tracking-widest font-bold whitespace-nowrap transition-colors duration-100 hover:bg-black hover:text-white hover:border-black";

// The fix buttons under one launch-readiness finding.
export function FindingFix({ f, onQuickFix, busy }) {
  // A buyer's own page uses its buyer page's delivery, so routing is fixed on that page.
  const fix = f.owner_page_id ? { link: `/admin/landing-pages/custom/${f.owner_page_id}`, linkLabel: `Open ${f.owner_name || "buyer"}'s buyer page` } : fixFor(f.code);
  if (!fix) return null;
  const open = () => {
    if (goToField(fix.target)) toast("Make the change, then press Save & re-check.", { duration: 4000 });
    else toast.error("That setting isn't shown for this page's form style.");
  };
  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
      {fix.quick && (
        <button type="button" disabled={busy} onClick={() => onQuickFix(fix.quick.patch)}
                className={`${BTN} border-black bg-black text-white disabled:opacity-40`} data-testid={`readiness-quickfix-${f.code}`}>
          {busy ? "Saving…" : `Fix now: ${fix.quick.label}`}
        </button>
      )}
      {fix.target && <button type="button" onClick={open} className={BTN} data-testid={`readiness-open-${f.code}`}>Open to fix</button>}
      {fix.link && <Link to={fix.link} className={BTN} data-testid={`readiness-link-${f.code}`}>{fix.linkLabel || "Open to fix"}</Link>}
      {fix.server && (
        <span className="text-[10px] italic" data-testid={`readiness-server-${f.code}`}>
          Server key, not a page setting — it shows as configured once the key is added on the live site.
        </span>
      )}
    </div>
  );
}
